export default "__VITE_ASSET__wVz0lAwA__"